import TextField from '@mui/material/TextField'
import size from 'lodash/size'
import React, { useEffect, useRef, useState } from 'react'
import { emailServicesDomains, protectedKeyCodes } from './constants'

const SuggestEmail = (props) => {
  const { value: valueProp = '' } = props
  const [value, setValue] = useState('')
  const [suggestion, setSuggestion] = useState('')
  let textHandler = useRef(null)

  const replaceLast = (val, what, replacement) => {
    if (!val) return ''
    const pieces = val.split(what)
    const lastPiece = pieces.pop()
    return pieces.join(what) + replacement + lastPiece
  }

  useEffect(() => {
    if (typeof suggestion !== 'undefined' && size(suggestion) > 0) {
      const startPos = value.lastIndexOf(suggestion)
      const endPos = startPos + size(suggestion)
      textHandler.setSelectionRange(startPos, endPos)
    }
  }, [suggestion])

  const suggestF = (string) => {
    const strArr = string.split('@')
    if (strArr.length - 1 !== 0) {
      string = strArr.pop()
    } else return

    const match = emailServicesDomains
      ?.filter((domain) => {
        return domain.indexOf(string) === 0
      })
      ?.shift() || ''

    return match?.replace(string, '')
  }

  const handleChange = (event) => {
    const { value: emailAddress } = event.target
    const { onChange } = props
    const suggest = suggestF(emailAddress)
    if (typeof suggest === 'undefined' || size(suggest) < 1) {
      setValue(emailAddress)
      event.target.value = emailAddress
    } else {
      setValue(`${emailAddress}${suggest}`)
      event.target.value = `${emailAddress}${suggest}`
    }
    setSuggestion(suggest)
    if (onChange) {
      onChange(event)
    }
  }

  const getSuggest = (event) => {
    const { onChange } = props
    if (protectedKeyCodes.indexOf(event.keyCode) >= 0) return
    const { value: val } = event.target

    if (event.keyCode === 8) {
      setValue(replaceLast(val, suggestion, ''))
      event.target.value = replaceLast(val, suggestion, '')
    }
    if (onChange) {
      onChange(event)
    }
  }

  useEffect(() => {
    setValue(valueProp)
  }, [])

  return (
    <TextField
      {...props}
      autoCapitalize="none"
      type="text"
      inputMode="email"
      value={value || ''}
      onChange={handleChange}
      onKeyUp={getSuggest}
      inputRef={(input) => {
        if (input) textHandler = input
      }}
    />
  )
}

export default SuggestEmail
